module.exports = __webpack_public_path__ + "img/badge_color_pop-entrance.612a12fc.svg";